module.exports = __webpack_public_path__ + "img/research_2.e6a53e74.png";